export const events = [
    "OPPORTUNITY_CREATED",
    "OPPORTUNITY_UPDATED",
    "OPPORTUNITY_LOST",
    "OPPORTUNITY_SOLD"
];